import { Reveal } from "../lib/motion";
import { Compass, Gamepad2, Boxes, Rocket } from "lucide-react";
import { useLang } from "../lib/i18n";
import { Kicker, SectionTitle, Watermark } from "./Shared";

const STEP_ICONS = [Compass, Gamepad2, Boxes, Rocket];

/**
 * Bloc 5 — méthode.
 * Une seule frise : CSS restyle en colonne sur mobile, grille dès tablette.
 */
export const Method = () => {
  const { t } = useLang();
  const m = t.method;

  return (
    <section
      id="methode"
      data-testid="method-section"
      className="relative pt-36 md:pt-48 pb-24 md:pb-32 overflow-hidden bg-section"
    >
      <Watermark n="04" />

      <div className="relative z-10 max-w-site mx-auto px-6 md:px-12">
        <Reveal className="mb-16 md:mb-24 max-w-3xl">
          <Kicker>{m.kicker}</Kicker>
          <SectionTitle lead={m.title[0]} accent={m.title[1]} stacked />
          <p className="mt-6 text-warm font-light leading-relaxed max-w-2xl">
            {m.desc}
          </p>
        </Reveal>

        <Reveal y={24}>
          <ol className="method-timeline method-timeline--grid list-none m-0 p-0">
            {m.steps.map((s, i) => {
              const Icon = STEP_ICONS[i];
              return (
                <li key={s.title} className="method-step">
                  <div className="method-step-icon" aria-hidden>
                    <span className="method-step-ring">
                      <Icon size={28} strokeWidth={1.35} />
                    </span>
                    <span className="method-step-stem" />
                  </div>

                  <div className="method-step-rail" aria-hidden>
                    <span className="method-step-node" />
                  </div>

                  <div className="method-step-body">
                    <span className="method-step-num">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <h3 className="method-step-title">{s.title}</h3>
                    <p className="method-step-desc">{s.desc}</p>
                  </div>
                </li>
              );
            })}
          </ol>
        </Reveal>
      </div>
    </section>
  );
};
